module.exports = __webpack_public_path__ + "img/pin.5de944f4.svg";